<div *ngIf="ogrenciAdinaBasvuruYapabilirMi" class="main-font-size">

  <div class="mb-3">
    <div class="row">
      <div class="col-9">
        <thm-input-text labelText="{{'ogrenciSecimi.tcNo' | transloco}}" [inputWidth]="11" [(model)]="tcNo"
          [readonly]="kendiTcNoKullanmakIstiyor">
        </thm-input-text>
      </div>
      <div class="col-3 d-flex align-items-center mt-2">
        <thm-button buttonType="success" iconClass="fas fa-arrow-circle-right" (clicked)="sorgula()"
          [loading]="buttonPassive" loadingType="border" loadingText="Sorgulanıyor">
          {{'ogrenciSecimi.sorgula' | transloco}}
        </thm-button>
      </div>
    </div>
    <div class="form-row">
      <div class="col-12">
        <aof-checkbox inputId="myCheckbox" labelText="{{'ogrenciSecimi.kendiTcNoKullanmakIstiyor' | transloco}}"
          [fontBold]="true" [wasValidated]="true" [value]="kendiTcNoKullanmakIstiyor"
          (valueChange)="onTcNoKullanmakIstiyorChange($event)">
        </aof-checkbox>
      </div>
    </div>
  </div>

  <div *ngIf="sorgulamaYapildiMi">
    <hr>
    <div class="form-row" *ngIf="sorgulamaBasariliMi">
      <div class="col-4">
        <label class="text-primary font-weight-bold">{{'ogrenciSecimi.islemYapilacakAday' | transloco}}:</label>
      </div>
      <div class="col-8" >
        {{islemYapilacakAday}}
      </div>
    </div>
    <div class="form-row mt-3">
      <div *ngIf="sorgulamaYapildiMi && sorgulamaBasariliMi" class="col-12">
        <div class="col-10 pt-2">
          <span *ngIf="sorgulamaYapildiMi && sorgulamaBasariliMi" class="text-success font-weight-bold">
            <span class="ng-star-inserted"><i class="fa fa-check" aria-hidden="true"></i></span>
            {{'ogrenciSecimi.sorgulamaBasarili' | transloco}}
          </span>

        </div>
        <div class="col-2 float-right">
          <thm-button (clicked)="tamam()" buttonType="primary">
            {{'ogrenciSecimi.tamam' | transloco}}
          </thm-button>
        </div>
      </div>

      <div class="col-12 pt-2" *ngIf="sorgulamaYapildiMi && profilEklenebilirMi">
        <span class="text-danger font-weight-bold">
          <span [innerHTML]="'ogrenciSecimi.sorgulamaBasarisiz' | transloco"></span>
        </span>
        <thm-form-row>
          <thm-form-field [label]="'ogrenciSecimi.ad' | transloco" class="col-lg-6 col-12">
            <aof-input-text [(model)]="ad" inputId="ad" textTransform="uppercase">
            </aof-input-text>

          </thm-form-field>
          <thm-form-field [label]="'ogrenciSecimi.soyad' | transloco" class="col-lg-6 col-12">
            <aof-input-text [(model)]="soyad" inputId="soyad" textTransform="uppercase">
            </aof-input-text>
          </thm-form-field>
        </thm-form-row>
        <thm-form-row>
          <thm-action-button path="ogrenci-secimi/profil-kaydet" [params]="{
                                        tcNo: tcNo,
                                        ad: ad,
                                        soyad: soyad,
                                        girisYapanId:  this.user.id,
                                        adminMi: this.ogrenciAdinaBasvuruYapabilirMi,
                                        kendiTcNoKullanmakIstiyor: this.kendiTcNoKullanmakIstiyor
                                      }" (actionPerformed)="islemBasarili()" (errorOccurred)="islemBasarisiz($event)"
            buttonType="success" iconClass="fa fa-save">
            {{'kaydet' |transloco}}
          </thm-action-button>
        </thm-form-row>
      </div>
    </div>

  </div>

</div>